// extracted by mini-css-extract-plugin
export default {"tooltip":"CQ-z","arrow":"DQ-z"};